import {Product} from "./product";
import type {Address, Service} from ".";

/**
 * A request from a customer, for a given service, but with unspecified start time and provider.
 *
 * If an ondemand request is accepted by one of our partners,
 * then the request will be used to create a booking.
 */
export class OnDemand extends Product {
  public readonly type = "OnDemand";
  earliestStart: string;
  latestStart: string;
  orderAddress: Address;

  constructor(service: Service, earliestStart: string, latestStart: string, orderAddress: Address) {
    super(service);
    this.earliestStart = earliestStart;
    this.latestStart = latestStart;
    this.orderAddress = orderAddress;
  }
}
